import { render, staticRenderFns } from "./ClientIndex.vue?vue&type=template&id=782c1c32&"
import script from "./ClientIndex.vue?vue&type=script&lang=js&"
export * from "./ClientIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports